<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-activity`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.68848 3C6.23579 3 6.50961 3.00002 6.71875 3.10645C6.90278 3.20021 7.05272 3.35015 7.14648 3.53418C7.25299 3.74332 7.25293 4.01709 7.25293 4.56445V20.4346C7.25293 20.9823 7.25308 21.2566 7.14648 21.4658C7.05271 21.6498 6.90274 21.7998 6.71875 21.8936C6.50962 21.9999 6.23568 22 5.68848 22H5.36621C4.81848 22 4.54417 22.0001 4.33496 21.8936C4.15103 21.7998 4.00198 21.6497 3.9082 21.4658C3.8016 21.2566 3.80078 20.9823 3.80078 20.4346V4.56445C3.80078 4.01697 3.80163 3.74334 3.9082 3.53418C4.00196 3.35021 4.151 3.20021 4.33496 3.10645C4.54417 2.99985 4.81846 3 5.36621 3H5.68848ZM14.0615 4.09863C16.741 4.09863 18.7038 4.21088 19.8154 4.29688C20.158 4.32338 20.3296 4.33652 20.4443 4.42383C20.5425 4.49854 20.6118 4.61545 20.6309 4.7373C20.6532 4.87978 20.5824 5.04071 20.4395 5.3623L18.7275 9.21387L20.4336 13.0527C20.5788 13.3795 20.6512 13.543 20.6289 13.6855C20.6096 13.8082 20.5404 13.925 20.4414 14C20.3263 14.0871 20.1504 14.0999 19.7998 14.126C18.6387 14.2125 16.6053 14.3291 14.0615 14.3291C10.0422 14.3291 7.29707 15.0011 7.25391 15.0117V4.39355C7.29374 4.38881 9.74953 4.09863 14.0615 4.09863Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillActivity',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
